"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2687],{

/***/ 692687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _404Page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/utils/themeImports.js + 1 modules
var themeImports = __webpack_require__(353978);
// EXTERNAL MODULE: ./src/utils/specificThemeRender.ts
var specificThemeRender = __webpack_require__(698616);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
;// CONCATENATED MODULE: ./src/assets/svgExports/SearchIcon404.js


var SearchIcon404 = function(param) {
    var height = param.height, width = param.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 201 200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "m132.534 99.053-33.146 33.144s11.787-3.681 28.728 2.209c2.85.991 7.618-3.778 6.628-6.628-5.891-16.94-2.21-28.725-2.21-28.725",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F7F7F7",
                fillRule: "evenodd",
                d: "M43.825 43.488c20.125-20.122 52.797-20.122 72.922 0 20.122 20.124 20.122 52.796 0 72.921-20.125 20.122-52.797 20.122-72.922 0-20.122-20.125-20.122-52.797 0-72.922",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E9E9E9",
                fillRule: "evenodd",
                d: "M110.081 37.856a52 52 0 0 1 6.666 5.631c20.122 20.125 20.122 52.797 0 72.922-20.125 20.122-52.797 20.122-72.922 0a53 53 0 0 1-3.347-3.681c19.506 6.338 41.8 1.763 57.288-13.725 16.518-16.519 20.625-40.781 12.315-61.147",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BABABA",
                fillRule: "evenodd",
                d: "M39.406 39.069c22.563-22.563 59.197-22.563 81.76 0 22.562 22.562 22.562 59.197 0 81.759-22.563 22.563-59.197 22.563-81.76 0-22.562-22.562-22.562-59.197 0-81.76m6.628 6.628c18.904-18.903 49.6-18.903 68.504 0 18.903 18.903 18.903 49.6 0 68.503-18.904 18.903-49.6 18.903-68.504 0-18.903-18.903-18.903-49.6 0-68.503",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BABABA",
                fillRule: "evenodd",
                d: "M28.49 105.656c-10.724-21.622-7.087-48.584 10.916-66.587 16.907-16.906 41.713-21.144 62.585-12.713a74.5 74.5 0 0 1 .09 10.325c-18.16-9.143-40.89-6.137-56.047 9.016-16.065 16.066-18.478 40.65-7.23 59.275-3.295.45-6.657.684-10.07.684z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "M125.584 145.134c-5.49-5.49-5.49-14.393 0-19.887 5.491-5.491 14.397-5.491 19.888 0l45.3 45.3c1.219 1.219-2.247 6.666-7.734 12.153-5.488 5.488-10.935 8.953-12.154 7.734z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E9E9E9",
                fillRule: "evenodd",
                d: "M125.584 145.134c-5.49-5.49-5.49-14.393 0-19.887 5.491-5.491 14.397-5.491 19.888 0l41 41c1.219 1.219-2.247 6.666-7.734 12.153-5.488 5.488-10.935 8.953-12.154 7.734z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "M73.666 70.11c-.072-2.979 1.047-5.154 2.772-6.429 2.712-2 6.765-1.915 8.965.563.944 1.065 1.49 2.572 1.506 4.478.038 4.572-2.106 7.244-4.206 10.01-2.825 3.727-5.647 7.559-5.997 13.956a3.127 3.127 0 0 0 6.244.34c.263-4.86 2.587-7.69 4.734-10.522 2.875-3.79 5.529-7.572 5.475-13.834-.03-3.681-1.259-6.522-3.084-8.578-4.263-4.8-12.09-5.319-17.347-1.444-3.15 2.325-5.44 6.175-5.312 11.606a3.127 3.127 0 0 0 6.25-.147",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                d: "M79.538 107.584a3.844 3.844 0 1 0 0-7.687 3.844 3.844 0 0 0 0 7.687"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "m135.775 26.553 9.375-15.625a3.124 3.124 0 1 0-5.359-3.216l-9.375 15.625a3.125 3.125 0 1 0 5.359 3.216M150.559 36.85l34.375-25a3.13 3.13 0 0 0 .691-4.366 3.13 3.13 0 0 0-4.366-.69l-34.375 25a3.127 3.127 0 0 0 3.675 5.056M155.728 56.103l25-6.25a3.126 3.126 0 1 0-1.515-6.062l-25 6.25a3.124 3.124 0 0 0 1.515 6.063",
                clipRule: "evenodd"
            })
        ]
    });
};
/* harmony default export */ var svgExports_SearchIcon404 = (SearchIcon404);

// EXTERNAL MODULE: ./src/utils/getWindowDimension.js
var getWindowDimension = __webpack_require__(37110);
// EXTERNAL MODULE: ./src/utils/handleRedirectToHomePage.js
var handleRedirectToHomePage = __webpack_require__(254051);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
;// CONCATENATED MODULE: ./src/containers/404Page/ErrorMsg.tsx







var ErrorMsg = function() {
    var store = (0,es/* useSelector */.v9)(function(state) {
        return {
            store: state.storeReducer.store
        };
    }).store;
    var isDesktop = (0,getWindowDimension/* default */.Z)().isDesktop;
    var ref = function() {
        var size = isDesktop ? 200 : 100;
        return {
            height: size,
            width: size
        };
    }(), height = ref.height, width = ref.width;
    var goToHomePage = function() {
        (0,handleRedirectToHomePage/* redirectToHomePage */.A)(routes.PATH.PRODUCT, store === null || store === void 0 ? void 0 : store.domain);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-static tw-flex tw-flex-col tw-bg-white ".concat(isDesktop ? "tw-my-[78px] tw-gap-[60px]" : "tw-my-[138px] tw-gap-[48px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-items-center ".concat(isDesktop ? "tw-gap-[40px]" : "tw-gap-[32px]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_SearchIcon404, {
                        height: height,
                        width: width
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "msg tw-flex tw-flex-col tw-gap-16 tw-text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-font-inter tw-text-[22px]/[32px] tw-font-semibold tw-text-[#000000] md:tw-text-[32px]/[44px] md:tw-font-semibold",
                                children: "Uh oh, this page does not exist."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "tw-font-inter tw-text-[14px] tw-font-normal tw-leading-[22px] tw-text-[#00000099] md:tw-text-[18px]/7",
                                children: [
                                    "You may have mistyped the address or the ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " page may have been removed."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: goToHomePage,
                    className: "tw-mx-auto tw-w-[90%] tw-cursor-pointer tw-rounded-lg tw-border-none tw-bg-[#2B74D8] tw-px-24 tw-py-10 tw-font-inter tw-text-[14px] tw-font-semibold tw-leading-8 tw-text-white md:tw-w-auto md:tw-text-[16px]",
                    children: "Go to home page"
                })
            })
        ]
    });
};
/* harmony default export */ var _404Page_ErrorMsg = (ErrorMsg);

// EXTERNAL MODULE: ./src/utils/ssrCommonApiCall.ts + 1 modules
var ssrCommonApiCall = __webpack_require__(122987);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
;// CONCATENATED MODULE: ./src/containers/404Page/index.tsx









var Error404 = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeInfo = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react.useEffect)(function() {
        (0,ssrCommonApiCall/* ssrDataCall */.z)([
            "collections",
            "categories",
            "seo"
        ], storeInfo).then(function(data) {
            dispatch((0,catalog/* saveCatalogCategories */.FF)((data === null || data === void 0 ? void 0 : data.catalogCategories) || []));
            dispatch((0,catalog/* saveCollections */.VN)((data === null || data === void 0 ? void 0 : data.collections) || []));
            dispatch((0,catalog/* saveCatalogTags */.Vj)((data === null || data === void 0 ? void 0 : data.catalogTags) || []));
        });
    }, [
        storeInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ErrorPage_wrapper",
        children: [
            (ref = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
                return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_404Page_ErrorMsg, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "EroorPage_body_wrapper",
                children: (ref3 = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.components) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Footer) === null || ref5 === void 0 ? void 0 : ref5.map(function(layout) {
                    return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
                })
            })
        ]
    });
};
/* harmony default export */ var _404Page = (Error404);


/***/ }),

/***/ 254051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ redirectToHomePage; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(540190);


var redirectToHomePage = function(path, domain) {
    next_router__WEBPACK_IMPORTED_MODULE_0___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_1__.getRoute)(path, domain));
};


/***/ }),

/***/ 698616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ specificThemeRender; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(167261);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186812);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(423653);



var specificThemeRender = function(storeData) {
    var isSubscriptionDemoPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var mainTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.theme) || {};
    var alternateTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.store_premium_theme) || {};
    var isPremium = storeData === null || storeData === void 0 ? void 0 : storeData.premium;
    if (isSubscriptionDemoPreview || storeData.internal_admin_access === 1 || (storeData === null || storeData === void 0 ? void 0 : storeData.new_subscription_status) !== src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_SUBSCRIPTIONS_STATUS.INACTIVE */ .W0.INACTIVE) return mainTheme;
    var toggleMobileView = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().commonReducer.toggleMobileView;
    if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o > 998) {
        return isPremium || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.is_demo) === 1 || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.brand_website_flag) > 0 ? mainTheme : toggleMobileView ? mainTheme : alternateTheme;
    }
    return mainTheme;
};


/***/ }),

/***/ 122987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ ssrDataCall; }
});

// UNUSED EXPORTS: ssrCollectiveCall

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./src/services/catalog.js
var catalog = __webpack_require__(471549);
// EXTERNAL MODULE: ./src/services/index.js + 3 modules
var services = __webpack_require__(974763);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
;// CONCATENATED MODULE: ./src/utils/basicUtils.js
var isProductTag = function(categoryId) {
    var productTags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return (productTags === null || productTags === void 0 ? void 0 : productTags.length) && productTags.findIndex(function(tag) {
        return tag.id === categoryId;
    }) >= 0;
};

;// CONCATENATED MODULE: ./src/utils/ssrCommonApiCall.ts








/**
 * @typedef {Object} SSRCollectiveData
 * @property {any} collections
 * @property {any} catalogCategories
 * @property {any} catalogTags
 * @property {any} seo
 * @property {any} canonicalApiParams
 */ /**
 * this function is for all common api calls used in SSR.
 * @param {Array} callType api calls to make
 * @param {Object} reducerState reducerState object sent as argument
 * @return {Promise<SSRCollectiveData>} object contains all api call response
 */ function ssrCollectiveCall(callType, reducerState) {
    return _ssrCollectiveCall.apply(this, arguments);
}
function _ssrCollectiveCall() {
    _ssrCollectiveCall = (0,_async_to_generator/* default */.Z)(function(callType, reducerState) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, propType, storeId, canonicalApiParams, categoryCollectionType, typeId, slug_url, featureLocks, data, promArr, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, type, ref22, isCollectionFeatureUnlocked, ref23, ref24, ref25, ref26, isSeoFeatureUnlocked, ref27, ref28, catalogCategoriesData, productTags, err, fetchData, collections, catalogCategories, catalogTags, seo, canonicalData;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    propType = {};
                    storeId = reducerState === null || reducerState === void 0 ? void 0 : (ref = reducerState.data) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : ref1.store_id;
                    canonicalApiParams = (reducerState === null || reducerState === void 0 ? void 0 : (ref2 = reducerState.data) === null || ref2 === void 0 ? void 0 : ref2.canonicalParams) || {};
                    if (canonicalApiParams) {
                        typeId = canonicalApiParams === null || canonicalApiParams === void 0 ? void 0 : canonicalApiParams.typeId;
                        slug_url = canonicalApiParams === null || canonicalApiParams === void 0 ? void 0 : canonicalApiParams.slug_url;
                    }
                    /*
    if store_id is non-empty, then go forth with the api calls
  */ if (!(callType === null || callType === void 0 ? void 0 : callType.length) || !storeId) return [
                        2,
                        propType
                    ];
                    featureLocks = reducerState === null || reducerState === void 0 ? void 0 : (ref3 = reducerState.data) === null || ref3 === void 0 ? void 0 : ref3.featureLocks;
                    if (!!featureLocks) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,services/* getFeatureLocks */.$$)(storeId)
                    ];
                case 1:
                    data = _state.sent().data;
                    featureLocks = data;
                    _state.label = 2;
                case 2:
                    promArr = [
                        null,
                        null,
                        null,
                        null
                    ];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        13,
                        14,
                        15
                    ]);
                    _iterator = callType[Symbol.iterator]();
                    _state.label = 4;
                case 4:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        12
                    ];
                    type = _step.value;
                    switch(type){
                        case "collections":
                            return [
                                3,
                                5
                            ];
                        case "categories":
                            return [
                                3,
                                6
                            ];
                        case "seo":
                            return [
                                3,
                                7
                            ];
                        case "canonicalData":
                            return [
                                3,
                                8
                            ];
                    }
                    return [
                        3,
                        10
                    ];
                case 5:
                    {
                        ;
                        isCollectionFeatureUnlocked = !(featureLocks === null || featureLocks === void 0 ? void 0 : (ref22 = featureLocks["collections"]) === null || ref22 === void 0 ? void 0 : ref22.is_locked);
                        if (isCollectionFeatureUnlocked) {
                            promArr[0] = (0,services/* getCollectionData */.G_)(storeId);
                        }
                        return [
                            3,
                            11
                        ];
                    }
                    _state.label = 6;
                case 6:
                    if (storeId) {
                        promArr[1] = (0,services/* getCatalogCategories */.kg)(storeId);
                    }
                    return [
                        3,
                        11
                    ];
                case 7:
                    isSeoFeatureUnlocked = !(featureLocks === null || featureLocks === void 0 ? void 0 : (ref23 = featureLocks["seo"]) === null || ref23 === void 0 ? void 0 : ref23.is_locked);
                    if (storeId && (reducerState === null || reducerState === void 0 ? void 0 : (ref24 = reducerState.data) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.store) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.domain_info) === null || ref26 === void 0 ? void 0 : ref26.domain_type) !== 0 && !!isSeoFeatureUnlocked) {
                        promArr[2] = (0,services/* getSEODetails */.bA)(storeId);
                    }
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!storeId) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        Promise.resolve(promArr[1])
                    ];
                case 9:
                    catalogCategoriesData = _state.sent();
                    productTags = (catalogCategoriesData === null || catalogCategoriesData === void 0 ? void 0 : (ref27 = catalogCategoriesData.data) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.tags) === null || ref28 === void 0 ? void 0 : ref28.filter(function(tag) {
                        return (tag === null || tag === void 0 ? void 0 : tag.is_active) === 1;
                    })) || [];
                    if (canonicalApiParams === null || canonicalApiParams === void 0 ? void 0 : canonicalApiParams.type) {
                        categoryCollectionType = canonicalApiParams.type;
                    } else if (canonicalApiParams === null || canonicalApiParams === void 0 ? void 0 : canonicalApiParams.slug_url) {
                        categoryCollectionType = constants/* PAGE_TYPE_ID.CATEGORY */.Rv.CATEGORY;
                    } else if (isProductTag(+typeId, productTags)) {
                        categoryCollectionType = constants/* PAGE_TYPE_ID.TAG */.Rv.TAG;
                    } else {
                        categoryCollectionType = constants/* PAGE_TYPE_ID.CATEGORY */.Rv.CATEGORY;
                    }
                    promArr[3] = (0,catalog/* getPageCanonicalUrl */.M5)({
                        storeId: storeId,
                        type: categoryCollectionType,
                        typeId: typeId,
                        slug_url: slug_url
                    });
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        11
                    ];
                case 11:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        4
                    ];
                case 12:
                    return [
                        3,
                        15
                    ];
                case 13:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        15
                    ];
                case 14:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        4,
                        Promise.all(promArr)
                    ];
                case 16:
                    fetchData = _state.sent();
                    collections = ((ref4 = fetchData[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.status) ? JSON.parse(((ref6 = fetchData[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.data) || []) : [];
                    catalogCategories = ((ref8 = fetchData[1]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : ref9.status) ? ((ref10 = fetchData[1]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.data) === null || ref11 === void 0 ? void 0 : ref11.store_categories) || [] : [];
                    catalogTags = ((ref12 = fetchData[1]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.data) === null || ref13 === void 0 ? void 0 : ref13.status) ? ((ref14 = fetchData[1]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.data) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.tags) === null || ref16 === void 0 ? void 0 : ref16.filter(function(tag) {
                        return (tag === null || tag === void 0 ? void 0 : tag.is_active) === 1;
                    })) || [] : [];
                    seo = ((ref17 = fetchData[2]) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.data) === null || ref18 === void 0 ? void 0 : ref18.status) ? JSON.parse(((ref19 = fetchData[2]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.data) === null || ref20 === void 0 ? void 0 : ref20.data) || {}) : null;
                    canonicalData = ((ref21 = fetchData[3]) === null || ref21 === void 0 ? void 0 : ref21.status) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fetchData[3]), {
                        type: categoryCollectionType
                    }) : null;
                    propType = {
                        collections: collections,
                        catalogCategories: catalogCategories,
                        catalogTags: catalogTags,
                        seo: seo,
                        canonicalData: canonicalData
                    };
                    return [
                        2,
                        propType
                    ];
            }
        });
    });
    return _ssrCollectiveCall.apply(this, arguments);
}
var ssrDataCall = function(callType, storeData) {
    var featureLocks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, canonicalParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    return ssrCollectiveCall(callType, {
        data: {
            store: storeData,
            featureLocks: featureLocks,
            canonicalParams: canonicalParams
        }
    });
};


/***/ })

}]);